import { defineXray } from "../src/xray/manifest.js";
import { SHELL_TOOL_NAMES } from "../src/mine/shell.js";
import { extractProcsOps, describeMissing } from "../extractors/procs/index.js";
import { collect, build, groupBy, anchor, ignore } from "../extractors/procs/spec.js";

export default defineXray({
  id: "procs",
  label: "Processes",
  title: "Processes and services an agent started, stopped or interrogated on the host — by name rather than pid, with whether the manager confirmed the change",

  consumer: "someone reviewing what an agent did to a machine's running processes",
  decision: "whether a process is in the state the agent believed, or the command returned without confirming anything",

  // MEASURED AS FORMATTING. seven ops in an entire corpus, and a kill command reads as a kill; the reading only matters beside the work that depended on it
  tab: false,
  tabReason: "seven ops in an entire corpus, and a kill command reads as a kill; the reading only matters beside the work that depended on it",
  // Trace-only, so this does not down-select a tab of its own — it is how the
  // LINEAGE window finds the prompts carrying this lens's work. Same matcher
  // its tab-bearing siblings use: every op here is read off a shell command.
  substrate: { label: "shell (process control)", match: (n) => SHELL_TOOL_NAMES.test(String(n).split("__").pop()) },

  feed: { domain: "procs" },
  extract: extractProcsOps, collect, group: build, groupBy, anchor, ignore,
  // The process NAME. The extractor falls back to `pid N` when it cannot recover
  // one, and a pid means something for minutes and on one machine only — evidence,
  // never identity, so it is not offered as a ref.
  lineage: {
    kind: "process",
    ref: (op) => (op.process && !op.process.startsWith("pid ") ? op.process : null),
    role: (op) => (op.kind === "inspect" ? "consultation" : "production"),
    text: (op) => op.output || "",
    label: (op) => `${op.kind} ${op.process}`,
    intent: (op) => (op.outcome === "unconfirmed" ? "state change unconfirmed" : null),
  },

  emptyNote: "No processes work in this window",
  explainMissing: describeMissing,
});
